<template>
    <div class="uebungen-library__uebung__result-dashboard w-full flex items-center justify-center p-4 ">
        <loading-dots v-if="isLoading"></loading-dots>
        <div v-else class="flex flex-col w-full max-w-6xl space-y-4">
            <!-- Dashboard Header -->

            <!-- Kompakte Statistik-Übersicht -->
            <div v-if="bestResultsPerUser.length > 0" class=" rounded-lg p-2 mb-2">
                <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <!-- Durchschnittliche Korrektheit -->
                    <div class="flex flex-col items-center justify-center">
                        <div class="w-48 flex flex-row items-center justify-start text-sm text-grey-600">
                            <i class="bx bx-check-circle text-lg mr-2"></i>
                            <span class="">Korrektheit</span>
                        </div>
                        <div class="text-2xl font-bold w-48 text-primary-600">{{ averageCorrectRatio }}%</div>
                    </div>

                    <!-- Durchschnittliche Zeit -->
                    <div class="flex flex-col items-center justify-center">
                        <div class="w-48 flex flex-row items-center justify-start text-sm text-grey-600">
                            <i class="bx bx-time text-lg mr-2"></i>
                            <span class="">Zeit-Verhältnis</span>
                        </div>
                        <div class="text-2xl font-bold w-48 text-primary-600">{{ averageTimeRatio }}%</div>
                    </div>

                    <!-- Durchschnittspunkte -->
                    <div class="flex flex-col items-center justify-center">
                        <div class="w-48 flex flex-row items-center justify-start text-sm text-grey-600">
                            <i class="bx bx-trophy text-lg mr-2"></i>
                            <span class="">Punkte-Durchschnitt</span>
                        </div>
                        <div class="text-2xl font-bold w-48 text-primary-600">{{ averageTotalPoints }}</div>
                    </div>

                    <!-- Teilnehmeranzahl -->
                    <div class="flex flex-col items-center justify-center">
                        <div class="w-48 flex flex-row items-center justify-start text-sm text-grey-600">
                            <i class="bx bx-group text-lg mr-2"></i>
                            <span class="">Teilnehmer</span>
                        </div>
                            <div class="flex flex-row items-center justify-start w-48">
                                <div class="text-2xl font-bold text-primary-600">{{ totalParticipants }}</div>
                            <div class="text-xs text-grey-500 ml-1">({{ totalAttempts }} Versuche)</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Ergebnistabelle -->
            <div v-if="bestResultsPerUser.length > 0" class="rounded-lg  overflow-hidden">
                <div class="overflow-x-auto">
                    <table class="w-full">
                        <thead class="bg-grey-50">
                            <tr>
                                <th class="px-4 py-3 text-left text-xs font-medium text-grey-500 uppercase w-10">
                                    Platz
                                </th>
                                <th class="px-4 py-3 text-left text-xs font-medium text-grey-500 uppercase">
                                    Benutzer
                                </th>
                                <th class="px-4 py-3 text-left text-xs font-medium text-grey-500 uppercase">
                                    Versuche
                                </th>
                                <th class="px-4 py-3 text-left text-xs font-medium text-grey-500 uppercase">
                                    Korrektheit
                                </th>
                                <th class="px-4 py-3 text-left text-xs font-medium text-grey-500 uppercase">
                                    Zeit
                                </th>
                                <th class="px-4 py-3 text-left text-xs font-medium text-grey-500 uppercase">
                                    Punkte
                                </th>
                                <th class="px-4 py-3 text-left text-xs font-medium text-grey-500 uppercase">
                                    Gravitas
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-grey-50">
                            <tr v-for="(result, index) in sortedResults" :key="result.id" class="hover:bg-grey-50"
                                :class="{ 'border-t border-grey-300': index > 0 }">
                                <td class="px-4 py-2 whitespace-nowrap">
                                    <span class="text-xs font-medium text-blue-600">{{ index + 1 }}</span>
                                </td>
                                <td class="px-4 py-2 whitespace-nowrap">
                                    <div class="flex items-center">
                                        <div>
                                            <div class="text-sm font-medium text-grey-900">{{ result.user.username }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="px-4 py-2 whitespace-nowrap">
                                    <span class="text-sm font-medium text-grey-600">{{ getAttemptsForUser(result.user.username) }}</span>
                                </td>
                                <td class="px-4 py-2 whitespace-nowrap">
                                    <div class="flex items-center">
                                       
                                        <span class="text-sm font-medium text-grey-900">{{ (result.score_correct_ratio *
                                            100).toFixed(1) }}%</span>
                                    </div>
                                </td>
                                <td class="px-4 py-2 whitespace-nowrap">
                                    <div class="flex items-center">
                                      
                                        <span class="text-sm font-medium text-grey-900">{{ (result.score_time_ratio *
                                            100).toFixed(1) }}%</span>
                                    </div>
                                </td>
                                <td class="px-4 py-2 whitespace-nowrap">
                                    <span class="text-sm font-bold ">{{ result.score_total_points
                                        }}</span>
                                </td>
                                <td class="px-4 py-2 whitespace-nowrap">
                                    <span class="text-sm font-bold ">{{ result.score_gravitas }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Leere Zustand -->
            <div v-else class=" rounded-lg             p-6 text-center">
                <i class="bx bx-info-circle text-4xl text-grey-400 mb-3"></i>
                <h3 class="text-lg font-semibold text-grey-600 mb-2">Keine Ergebnisse verfügbar</h3>
                <p class="text-grey-500">Für diese Übung sind noch keine Ergebnisse vorhanden.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { haxiosAPIClient } from "@/haxios/haxios.js";
export default {
    name: "uebungen-libary-absolved-stats-dashboard",

    data() {
        return {
            isLoading: true,
            stats: null
        }
    },
    props: {
        uebung: {
            type: Object,
            required: true
        }
    },
    computed: {
        /**
         * Extrahiert das beste Ergebnis pro Benutzer aus den gruppierten Daten
         */
        bestResultsPerUser() {
            if (!this.stats?.data?.uebung?.length) return [];
            
            return this.stats.data.uebung.map(userRecords => {
                // Sortiere die Records des Benutzers nach Gesamtpunkten (absteigend) und dann nach Korrektheit
                const sortedRecords = userRecords.sort((a, b) => {
                    if (b.score_total_points !== a.score_total_points) {
                        return b.score_total_points - a.score_total_points;
                    }
                    return b.score_correct_ratio - a.score_correct_ratio;
                });
                
                // Nimm das beste Ergebnis (erstes nach Sortierung)
                return sortedRecords[0];
            });
        },

        /**
         * Berechnet die durchschnittliche Korrektheit aller Benutzer (beste Ergebnisse)
         */
        averageCorrectRatio() {
            if (!this.bestResultsPerUser.length) return 0;
            const total = this.bestResultsPerUser.reduce((sum, result) => sum + result.score_correct_ratio, 0);
            return ((total / this.bestResultsPerUser.length) * 100).toFixed(1);
        },

        /**
         * Berechnet das durchschnittliche Zeitverhältnis aller Benutzer (beste Ergebnisse)
         */
        averageTimeRatio() {
            if (!this.bestResultsPerUser.length) return 0;
            const total = this.bestResultsPerUser.reduce((sum, result) => sum + result.score_time_ratio, 0);
            return ((total / this.bestResultsPerUser.length) * 100).toFixed(1);
        },

        /**
         * Berechnet die durchschnittlichen Gesamtpunkte aller Benutzer (beste Ergebnisse)
         */
        averageTotalPoints() {
            if (!this.bestResultsPerUser.length) return 0;
            const total = this.bestResultsPerUser.reduce((sum, result) => sum + result.score_total_points, 0);
            return (total / this.bestResultsPerUser.length).toFixed(1);
        },

        /**
         * Gibt die Gesamtanzahl der Benutzer zurück
         */
        totalParticipants() {
            return this.bestResultsPerUser.length;
        },

        /**
         * Berechnet die Gesamtanzahl aller Versuche über alle Benutzer
         */
        totalAttempts() {
            if (!this.stats?.data?.uebung?.length) return 0;
            return this.stats.data.uebung.reduce((total, userRecords) => total + userRecords.length, 0);
        },

        /**
         * Sortiert die besten Ergebnisse nach Gesamtpunkten (absteigend)
         */
        sortedResults() {
            if (!this.bestResultsPerUser.length) return [];
            return [...this.bestResultsPerUser].sort((a, b) => {
                // Primär nach Gesamtpunkten sortieren
                if (b.score_total_points !== a.score_total_points) {
                    return b.score_total_points - a.score_total_points;
                }
                // Sekundär nach Korrektheit sortieren
                return b.score_correct_ratio - a.score_correct_ratio;
            });
        }
    },
    methods: {
        /**
         * Berechnet die Anzahl der Versuche für einen bestimmten Benutzer
         */
        getAttemptsForUser(username) {
            if (!this.stats?.data?.uebung?.length) return 0;
            const userRecordsArray = this.stats.data.uebung.find(userRecords => 
                userRecords.length > 0 && userRecords[0].user.username === username
            );
            return userRecordsArray?.length || 0;
        },

        /**
         * Lädt die Statistikdaten für die Übung
         */
        getStats() {
            haxiosAPIClient.get(`/uebungen/absolved-records/index/${this.uebung.id}`).then(response => {
                this.stats = response.data;
                this.isLoading = false;
            }).catch(error => {
                console.error('Fehler beim Laden der Statistiken:', error);
                this.isLoading = false;
            });
        }
    },
    mounted() {
        this.getStats();
    }
}
</script>

<style scoped></style>